import { WmTabList, WmTabItem } from "@watermarkinsights/ripple-react";
import { TabOption } from "../interfaces/Interface";

interface InsightsTabComponentProps {
  tabOption: TabOption[];
  selectedTab: string;
  onWmTabSelected: (event: any) => void;
}

export const pageSize = 4;

export const isTaskInCurrentPage = (index: number, currentPage: number) => {
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = currentPage * pageSize;
  return index >= startIndex && index < endIndex;
};

export default function InsightsTabComponent(props: InsightsTabComponentProps) {
  let st = props.tabOption.filter((tab: TabOption) => {
    return tab.id === props.selectedTab;
  });
  const selectedTab =
    st.length > 0 ? props.selectedTab : "institution-insights";

  return (
    <WmTabList
      id="tab-with-controllers"
      selectedTab={selectedTab}
      onWmTabSelected={props.onWmTabSelected}
    >
      {props.tabOption.map((tab: TabOption) => (
        <WmTabItem id={tab.id} tabId={tab.id} key={tab.id}>
          {tab.name}
        </WmTabItem>
      ))}
    </WmTabList>
  );
}
